import { useState } from "react";

interface Message {
  Id: number;
  Name: string;
  Message: string;
  CreatedAt: string;
}

export default function MessagesTest() {
  const [messages, setMessages] = useState<Message[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // GET messages
  const fetchMessages = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch("https://www.dreamstriphub.com/api/test.php");
      if (!res.ok) {
        throw new Error(`Server returned ${res.status} ${res.statusText}`);
      }
      const data: Message[] = await res.json();
      setMessages(data);
    } catch (err: any) {
      setError(err.message || "Failed to fetch messages.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 600, margin: "0 auto", padding: 20 }}>
      <h2>📨 Test Messages API</h2>

      <button onClick={fetchMessages} disabled={loading}>
        {loading ? "Loading..." : "Load Messages"}
      </button>

      {error && <p style={{ color: "red" }}>{error}</p>}

      <ul>
        {messages.map((m) => (
          <li key={m.Id}>
            <b>{m.Name}</b>: {m.Message}{" "}
            <i>({new Date(m.CreatedAt).toLocaleString()})</i>
          </li>
        ))}
      </ul>
    </div>
  );
}
